import { Sparkles, Loader2, RefreshCw } from "lucide-react";
import DOMPurify from "dompurify";

function renderAnalysis(text) {
  if (!text) return null;
  return text.split("\n").map((line, i) => {
    if (line.startsWith("**") && line.endsWith("**")) {
      return <h3 key={i} className="text-base font-black mt-5 mb-1.5" style={{ color: "#FFC82E", fontFamily: "Outfit, sans-serif" }}>{line.replace(/\*\*/g, "")}</h3>;
    }
    if (line.startsWith("**")) {
      return <p key={i} className="font-black text-sm mb-1" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(line.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")) }} />;
    }
    if (!line.trim()) return <div key={i} className="h-2" />;
    return <p key={i} className="text-sm leading-relaxed mb-1">{line}</p>;
  });
}

export function AIAnalysisSection({ aiAnalysis, aiLoading, aiCached, generateAnalysis, politician, surface, text, textSec }) {
  return (
    <section data-testid="ai-analysis-section">
      <h2 className="text-xl font-black mb-4 pb-2 border-b-2 border-black flex items-center gap-2" style={{ color: text, fontFamily: "Outfit, sans-serif" }}>
        <Sparkles className="w-5 h-5" style={{ color: "#FFC82E" }} />
        AI Political Analysis
      </h2>

      {!aiAnalysis && (
        <div className="border-2 border-black p-6 text-center" style={{ backgroundColor: surface }}>
          <Sparkles className="w-8 h-8 mx-auto mb-3" style={{ color: "#FFC82E" }} />
          <p className="font-black text-base mb-1" style={{ color: text }}>Get an AI-powered deep dive</p>
          <p className="text-sm mb-4" style={{ color: textSec }}>
            Generate a balanced, evidence-based analysis of {politician?.name}'s political record, voting patterns, key achievements, and what they truly stand for.
          </p>
          <button
            onClick={generateAnalysis}
            disabled={aiLoading}
            className="flex items-center gap-2 mx-auto px-6 py-2.5 border-2 border-black font-black text-sm transition-all hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ backgroundColor: "#FFC82E", color: "#000", boxShadow: "3px 3px 0 #000" }}
            data-testid="generate-analysis-btn"
          >
            {aiLoading ? <><Loader2 className="w-4 h-4 animate-spin" /> Generating…</> : <><Sparkles className="w-4 h-4" /> Generate Analysis</>}
          </button>
        </div>
      )}

      {aiAnalysis && (
        <div className="border-2 border-black p-6" style={{ backgroundColor: surface, boxShadow: "3px 3px 0 #000" }} data-testid="ai-analysis-content">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Sparkles className="w-4 h-4" style={{ color: "#FFC82E" }} />
              <span className="text-xs font-black" style={{ color: "#FFC82E" }}>AI ANALYSIS — GPT-4o</span>
              {aiCached && <span className="text-xs px-1.5 py-0.5 border border-current font-bold" style={{ color: "#64748B" }}>cached</span>}
            </div>
            <button onClick={generateAnalysis} disabled={aiLoading} className="flex items-center gap-1 text-xs font-bold hover:opacity-75 transition-opacity" style={{ color: textSec }} data-testid="regenerate-analysis-btn" title="Regenerate analysis">
              {aiLoading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
              Refresh
            </button>
          </div>
          <div style={{ color: text }}>{renderAnalysis(aiAnalysis)}</div>
        </div>
      )}
    </section>
  );
}
